import { useQueryClient } from '@tanstack/react-query';
import { PHONE_REQUEST_PARAM } from '@telega/shared';
import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { templateKey } from '../api/template';
import { uk } from '../i18n/uk';
import { haptic, requestContact } from '../telegram';
import { useToast } from '../ui';

/**
 * The welcome's "📱 Поділитися телефоном" button opens the Mini App with `?request_phone=1`:
 * Telegram's phone dialog shows right away, so sharing takes one tap (and Telegram's confirm).
 */
export function PhoneRequest() {
  const location = useLocation();
  const navigate = useNavigate();
  const toast = useToast();
  const qc = useQueryClient();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;
    const params = new URLSearchParams(location.search);
    if (!params.has(PHONE_REQUEST_PARAM)) return;
    params.delete(PHONE_REQUEST_PARAM);
    const search = params.toString();
    navigate(
      { pathname: location.pathname, search: search ? `?${search}` : '' },
      { replace: true },
    );
    void requestContact().then((shared) => {
      if (!shared) return;
      haptic.success();
      toast(uk.auth.phoneSaved);
      // The template shows the phone as its default contact.
      void qc.invalidateQueries({ queryKey: templateKey });
    });
  }, [location, navigate, toast, qc]);
  return null;
}
